import React, {useState, useRef} from "react";

const FaqCom = ({post, index, toggleFAQ}) => {

    const [setActive, setActiveState] = useState("")
    const [setHeight, setHeightState] = useState("0px")

    const content = useRef(null);

    function toggleAccordion() {
        setActiveState(setActive === "" ? "active" : "");
        setHeightState(setActive === "active" ? "0px" : `${content.current.scrollHeight}px`)
        console.log(content.current.scrollHeight);
    }

    return (
        <>


            {
                <div className="faq__accordion_content">
                    <button className={`text-jost-sb-24-blk faq__accordion_btn
                     ${setActive}`}
                            key={index}
                            onClick={toggleAccordion}>
                        {
                            // `${post.title}`
                            <span>{post.title}</span>
                        }
                    </button>
                    <div className="faq__accordion_content_panel"
                         ref={content}
                         style={{maxHeight: `${setHeight}`}}>
                        <div className="text-ops-rg-22-wt"
                             key={post.id}
                             dangerouslySetInnerHTML={{__html: post.description}}
                        />

                    </div>

                </div>


            }


        </>
    );
};
export default FaqCom;